import { lazy } from 'react';
export const Correspondence = lazy(() => import('@/Portal/Correspondence/Correspondence'));
